import { render, staticRenderFns } from "./CreateMenuModal.vue?vue&type=template&id=9fa3a4fc&scoped=true&"
import script from "./CreateMenuModal.vue?vue&type=script&lang=ts&"
export * from "./CreateMenuModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMenuModal.vue?vue&type=style&index=0&id=9fa3a4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa3a4fc",
  null
  
)

export default component.exports